import ApiClient from './apiClient'
import {
  ArticleIndex,
  PostArticleParams,
  ReadArticle,
} from '../types/notice'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getNoticeList = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/notice',
  (result: ArticleIndex) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postNotice = async (params: PostArticleParams): Promise<any> => ApiClient.post(
  '/api/v1/renderer/notice',
  (result: ReadArticle) => result,
  params,
)
